import { useEffect, useRef, useState } from "react";
import styles from "./Table.module.scss";
import { getZonedTime } from "utils/trackingTransform";
import { createEmailsField, sortDescending, sortAscending } from "../../utils";
import Popup from "../Popup";

const Table = ({
  data,
  isActiveTab,
  setHidden,
  groupIndex,
  photos,
  info,
  setShowDetailPopup,
  setPopupDetails,
  timezone,
}) => {
  const ref = useRef();
  const popupRef = useRef();
  const [sorted, setSorted] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [activeRow, setActiveRow] = useState();

  function setHeaderHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--thead-height",
        `${ref.current?.offsetHeight}px`
      );
    }
  }

  useEffect(() => {
    isActiveTab === 2 && setHeaderHeight();
  }, [isActiveTab]);

  const createResult = (data) => {
    const array = [].concat(
      data?.calls ?? [],
      data?.emails ?? [],
      (data?.chat_bids ?? []).map((item) => ({ ...item, event_type: "chat_bid" })),
      (data?.timetracking ?? []).map((item) => ({ "Clock In": item?.clock_in })),
      (data?.timetracking ?? []).map((item) => ({ "Clock Out": item?.clock_out })),
    );
    if (data?.scheduled_shift_start) {
      array.push({ "Scheduled In": data.scheduled_shift_start });
    }
    if (data?.scheduled_shift_end) {
      array.push({ "Scheduled Out": data.scheduled_shift_end });
    }

    return array;
  };

  const handleClickRow = (e, item) => {
    const currentIdNumber = e.target.parentElement.id;
    const allData = Object.assign(
      {
        photos,
        info,
        groupIndex,
        currentData: item,
      },
      {
        position: e.target.parentElement.getBoundingClientRect().top,
      }
    );
    setPopupData(allData);
    if (
      Object.keys(item)[0] !== "Clock Out" &&
      Object.keys(item)[0] !== "Clock In"
    ) {
      setShowPopup(true);
      setHidden(true);
      setActiveRow(currentIdNumber);
    } else {
      setShowPopup(false);
      setHidden(false);
      setActiveRow();
    }
  };

  return (
    <>
      <table className={styles.content}>
        <thead className={styles.header} ref={ref}>
          <tr className={styles.row}>
            <th onClick={() => setSorted((prev) => !prev)}>Time</th>
            <th>Event Type</th>
            <th>From</th>
            <th>To</th>
            <th>Duration</th>
            <th>Subject</th>
          </tr>
        </thead>

        <tbody className={styles.body}>
          {(sorted
            ? sortDescending(createResult(data))
            : sortAscending(createResult(data))
          )?.map((item, index) => {
            return (
              <tr
                id={`${groupIndex}${index}`}
                key={index}
                onClick={(e) => {
                  handleClickRow(e, item);
                }}
                className={
                  activeRow === `${groupIndex}${index}` ? styles.active : ""
                }
              >
                <td>
                  {getZonedTime(
                    item?.["Clock In"] ??
                      item?.["Clock Out"] ??
                      item?.sent_date ??
                      item?.call_date_time ??
                      item?.["Scheduled In"] ??
                      item?.["Scheduled Out"],
                    timezone,
                  )}
                </td>
                <td
                  style={
                    item?.event_type === "chat_bid"
                      ? { color: "#F5A623" }
                      : item?.is_incoming === "outbound"
                      ? { color: "#167CB8" }
                      : item?.is_incoming === "inbound"
                      ? { color: "#D47174" }
                      : item?.gmail_id !== undefined
                      ? { color: "#00C193" }
                      : {}
                  }
                >
                  {Object.keys(item).length === 1
                    ? Object.keys(item)[0]
                    : item?.event_type === "chat_bid"
                    ? "Chat Bid"
                    : item?.is_incoming === "outbound"
                    ? "Outgoing Call"
                    : item?.is_incoming === "inbound"
                    ? "Incoming Call"
                    : "Outgoing Email"}
                </td>
                <td>
                  {item?.is_incoming === "inbound"
                    ? item?.destination_or_caller
                    : item?.email_from &&
                      createEmailsField(item?.email_from, true)}
                </td>
                <td>
                  {item?.is_incoming === "outbound"
                    ? item?.destination_or_caller
                    : item?.email_to && createEmailsField(item?.email_to, true)}
                </td>
                <td>{item?.duration ?? (item?.gmail_id && "-")}</td>
                <td className={styles.truncate}>
                  {item?.subject ?? (item?.duration && "-")}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {showPopup && (
        <Popup
          data={popupData}
          setShowPopup={setShowPopup}
          ref={popupRef}
          setHidden={setHidden}
          setActiveRow={setActiveRow}
          setShowDetailPopup={setShowDetailPopup}
          setPopupDetails={setPopupDetails}
          timezone={timezone}
        />
      )}
    </>
  );
};

export default Table;
